module.exports = __webpack_public_path__ + "img/banner_title.2e875f32.png";